module.exports = __webpack_public_path__ + "static/media/nibss-logo-alone.39752d0b.svg";